import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TariffNatureMaintenanceCont from "presentation/view/container/TariffNature/TariffNatureContMain";

CommonEntrypoint(<TariffNatureMaintenanceCont/>)